import { createAsyncThunk } from '@reduxjs/toolkit';
import Endpoints from 'constants/endpoints';
import { UTC_TIMEZONE } from 'constants/general';
import {
  BulkConsistencyStatsRequest,
  BulkConsistencyStatsResponse,
  LogsByActivityInTimeRangePayload,
  StatsByActivityPerDayPayload
} from 'interfaces/stats.interface';
import focusBearApi from 'services/axios-config';
import { captureException } from 'services/posthog.service';

export const getHabitsConsistencyStats = createAsyncThunk(
  'stats/get_habits_consistency_stats',
  async (body: BulkConsistencyStatsRequest, { rejectWithValue }) => {
    try {
      const { data } = await focusBearApi.post<BulkConsistencyStatsResponse>(
        Endpoints.COMPLETED_ACTIVITY_CONSISTENCY_STATS,
        body
      );
      return data?.habits ?? [];
    } catch (error) {
      captureException(error);
      return rejectWithValue(undefined);
    }
  }
);

// deprecated
export const getStatsByActivityPerDay = createAsyncThunk(
  'stats/get_stats_by_activity_per_day',
  async ({
    activity_id,
    days_number,
    timezone
  }: StatsByActivityPerDayPayload) => {
    try {
      const { data } = await focusBearApi.get(
        `${Endpoints.COMPLETED_ACTIVITY}/${activity_id}`,
        { params: { days_number, timezone } }
      );
      return data ?? [];
    } catch (error) {
      captureException(error);
    }
  }
);

export const getCompletedLogsByActivityInTimeRange = createAsyncThunk(
  'stats/get_completed_logs_by_activity_in_time_range',
  async ({
    activity_id,
    days_number,
    timezone
  }: LogsByActivityInTimeRangePayload) => {
    try {
      const { data } = await focusBearApi.get(
        `${Endpoints.COMPLETED_ACTIVITY}/${activity_id}/stats`,
        { params: { days_number, timezone: timezone || UTC_TIMEZONE } }
      );
      return data?.items ?? [];
    } catch (error) {
      captureException(error);
    }
  }
);

export const getCompleteActivityLogQuestionsAnswers = createAsyncThunk(
  'stats/get_completed_activity_log_questions_answers',
  async (question_id: string) => {
    try {
      const { data } = await focusBearApi.get(
        Endpoints.COMPLETED_ACTIVITY_LOG_QUESTION_STATS(question_id)
      );
      return data?.items ?? [];
    } catch (error) {
      captureException(error);
    }
  }
);
